import React from 'react'
import styled from 'styled-components'

import Select, { components } from 'react-select'
import { Checkbox } from './check-box'

import { FONTS } from '../../constants'

const MultiValueContainer = ({ selectProps, data }) => {
  const label = data.label
  const allSelected = selectProps.value
  const index = allSelected.findIndex(selected => selected.label === label)
  const isLastSelected = index === allSelected.length - 1
  const labelSuffix = isLastSelected ? `` : ', '
  const val = `${label}${labelSuffix}`
  return val
}

const Option = props => {
  return (
    <components.Option { ...props }>
      <Row>
        <Checkbox
          id={ `checkbox-${props.label}` }
          style={ { marginRight: 5 } }
          checked={ props.isSelected }
          onChange={ () => {} }
        />
        { `${props.label}` }
      </Row>
    </components.Option>
  )
}

export const CheckboxSelect = (props) => {
  return (
    <Root width={ props.width } height={ props.height }>
      <SelectField
        isMulti
        closeMenuOnSelect={ false }
        isSearchable={ false }
        isClearable={ false }
        hideSelectedOptions={ false }
        backspaceRemovesValue={ false }
        styles={ customStyles }
        placeholder={ props.placeholder || 'Select Here' }
        menuPlacement={ props.menuPlacement || 'auto' }
        menuPosition={ props.menuPosition || 'fixed' }
        components={ { Option, MultiValueContainer } }
        { ...props }
      />
    </Root>
  )
}

const customStyles = {
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isFocused ? '#DEEBFF' : 'white',
    color: state.isDisabled ? '#CCCCCC' : 'black',
  }),
  menu: (base, state) => ({
    ...base,
    background: state.isDisabled ? '#EAEAEA' : '#FFFFFF',
    padding: 0,
  }),
  container: base => ({
    ...base,
    height: '100%',
    minHeight: '100%',
  }),
  valueContainer: (base) => ({
    ...base,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    display: 'initial',
  }),
  control: (base, state) => ({
    ...base,
    height: '100%',
    minHeight: '100%',
    padding: 0,
    border: 'none',
    background: state.isDisabled ? '#EAEAEA' : '#FFFFFF',
    fontFamily: FONTS.GOTHAM,
    fontSize: FONTS.SMALL_SIZE,
    boxShadow: 'none',
  }),
  dropdownIndicator: base => ({
    ...base,
    height: '100%',
    minHeight: '100%',
    padding: '4px 6px',
    alignItems: 'center',
  }),
  indicatorSeparator: base => ({
    ...base,
    display: 'none',
  }),
  placeholder: base => ({
    ...base,
    height: '100%',
    minHeight: '100%',
    display: 'flex',
    alignItems: 'center',
    fontSize: FONTS.SMALL_SIZE,
    color: '#C4C4C4',
    whiteSpace: 'nowrap',
  }),
  input: base => ({
    ...base,
    margin: '0 2px',
  }),
  singleValue: (base, state) => ({
    ...base,
    color: state.isDisabled ? '#808080' : '#333333',
    fontSize: FONTS.SMALL_SIZE,
  }),
  multiValue: base => ({
    ...base,
    fontSize: '14px',
  }),
  multiValueLabel: (base, state) => ({
    ...base,
    color: state.isDisabled ? '#808080' : '#333333',
  }),
  multiValueRemove: (base, state) => ({
    ...base,
    color: state.isDisabled ? '#808080' : '#333333',
  }),
}

const Root = styled.div`
    width: ${p => p.width || '100%'};
    min-height: ${p => p.height || '30px'};
    max-height: ${p => p.height || '30px'};
    height: 100%;
`

const SelectField = styled(Select)`
    width: 100%;
    height: 100%;
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    color: #333333;
    border: 1px solid #C4C4C4;
    border-radius: 4px;

    ${p => p.invalid && `
      border: 1px solid #dc3545;
    `}

    :focus {
      outline: none;
      box-shadow: none;
      border: 1px solid #C4C4C4;
    }

    :disabled {
      background: #EAEAEA;
      color: #C4C4C4;
    }
`

const Row = styled.div`
  display: flex;
  align-items: center;
`



// WEBPACK FOOTER //
// ./src/components/input/checkbox-select.js